import React from 'react';
import { FormattedMessage } from 'react-intl';

import { localize } from 'common/utils';
import { useCountryConfigContext } from 'modules/country/CountryConfigContext';

import { Option, OptionValue } from '../../../types';
import { OptionChoicesWithPopover } from '../../OptionHeader/OptionChoicesWithPopover';
import { OptionBindingActions } from '../OptionBindingActions';
import { optionTypeToTranslationMap } from '../constants';
import {
  HeaderLeft,
  HeaderNameAndChoices,
  HeaderNameAndTags,
  HeaderWrapper,
  Header,
  HeaderName,
  HeaderTags,
  HeaderOptionTypeTag,
  HeaderDisabledChoicesTag,
} from '../styles';

type Props = {
  className?: string;
  option: Option;
  optionBindingId: string;
  onDeleteOptionBinding: (id: string) => void;
  primaryLanguage: Language;
};

export const OptionBindingHeaderFormSection = ({
  className,
  option,
  optionBindingId,
  primaryLanguage,
  onDeleteOptionBinding,
}: Props) => {
  const { currency } = useCountryConfigContext();

  const numOfDisabledChoices = option.values.reduce((acc: number, choice: OptionValue) => {
    return !choice.enabled.enabled ? acc + 1 : acc;
  }, 0);

  return (
    <HeaderWrapper className={className}>
      <Header>
        <HeaderLeft>
          <HeaderNameAndChoices>
            <HeaderNameAndTags>
              <HeaderName dir="auto" lang={primaryLanguage}>
                {localize(option.name, primaryLanguage)}
              </HeaderName>
              <HeaderTags>
                <HeaderOptionTypeTag>
                  <FormattedMessage id={optionTypeToTranslationMap[option.type]} />
                </HeaderOptionTypeTag>
                {numOfDisabledChoices > 0 && (
                  <HeaderDisabledChoicesTag>
                    <FormattedMessage
                      id="menu-option.disabled-choices-with-count"
                      values={{ count: numOfDisabledChoices }}
                    />
                  </HeaderDisabledChoicesTag>
                )}
              </HeaderTags>
            </HeaderNameAndTags>

            <OptionChoicesWithPopover
              optionChoices={option.values}
              primaryLanguage={primaryLanguage}
              currency={currency}
            />
          </HeaderNameAndChoices>
        </HeaderLeft>
        <OptionBindingActions onDeleteOptionBinding={() => onDeleteOptionBinding(optionBindingId)} />
      </Header>
    </HeaderWrapper>
  );
};
